import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * Пояснение в потоке экрана. Нужно там, где связь между разделами неочевидна
 * (например, почему подписки не входят в бюджет) — но это справка, а не
 * алерт: сноска под группой, как в настройках iOS.
 */
export function InfoNote({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <div
      className={cn(
        'px-4 text-[13px] leading-snug text-muted-foreground',
        className,
      )}
    >
      {children}
    </div>
  );
}